import { render, staticRenderFns } from "./TheHomeBridesman.vue?vue&type=template&id=32853d0f&scoped=true"
import script from "./TheHomeBridesman.vue?vue&type=script&lang=js"
export * from "./TheHomeBridesman.vue?vue&type=script&lang=js"
import style0 from "./TheHomeBridesman.vue?vue&type=style&index=0&id=32853d0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32853d0f",
  null
  
)

export default component.exports